import { render, staticRenderFns } from "./CoachSharesAdminDashboard.vue?vue&type=template&id=50137717&scoped=true&"
import script from "./CoachSharesAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./CoachSharesAdminDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50137717",
  null
  
)

export default component.exports